import Vue from 'vue';
import VueRouter from 'vue-router';
import 'bootstrap';
import VTooltip from 'v-tooltip';
import VueDatetime from 'vue-datetime';
import Snotify from 'vue-snotify';
import loaderUrl from '@momsfriendlydevco/loader/dist/loader.js?url';

globalThis.Vue = Vue;

Vue.use(VueRouter);
Vue.use(VTooltip);
Vue.use(VueDatetime);
Vue.use(Snotify);

// This package exposes Loader only through a classic script, with no module export.
export const loaderReady = globalThis.Loader ? Promise.resolve(globalThis.Loader) : new Promise((resolve, reject) => {
	const script = document.createElement('script');
	script.src = loaderUrl;
	script.addEventListener('load', () => {
		document.removeEventListener('DOMContentLoaded', globalThis.Loader.init);
		if (!document.querySelector('.loader-bar')) globalThis.Loader.init();
		resolve(globalThis.Loader);
	}, {once: true});
	script.addEventListener('error', () => reject(new Error('Unable to load the loading indicator')), {once: true});
	document.head.append(script);
});
